/* Custom kart code starts */
const discountWrapperElement = document.querySelector(
  ".custom-cart-discount-wrapper"
);

const discountApplyBtn = document.querySelector("#apply-coupon-btn");

Shopify.CustomDiscountSubmit = function (requestCouponCode) {
  document.querySelector(".discount-main-container")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest",
  });
  let customDiscountTextValue = document
    .querySelector("#custom-discount-text")
    .value.trim();
  if (customDiscountTextValue === "") {
    customDiscountTextValue = requestCouponCode;
  }
  let couponCodeValue = customDiscountTextValue
    ? customDiscountTextValue
    : requestCouponCode;

  if (customDiscountTextValue === "") {
    return;
  }
  if (discountApplyBtn) {
    discountApplyBtn.classList.add("btn-loading");
    discountApplyBtn.setAttribute("disabled", true);
    const applyText = discountApplyBtn.querySelector("#apply-text");
    const spinner = discountApplyBtn.querySelector(".nb-spinner");
    if (applyText) applyText.style.display = "none";
    if (spinner) spinner.style.display = "block";
  }

  // Define the button element
  const discountButton = document.querySelector(".back-button-discount-header");
  function triggerDiscountButtonClick() {
    if (discountButton) {
      discountButton.click();
    } else {
      console.warn("Button not found!");
    }
  }

  document.querySelector("#custom-discount-text").value = couponCodeValue;

  if (couponCodeValue) {
    setTimeout(() => {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          applyDiscount(cart, couponCodeValue);
        });
    }, 500);
  } else {
    resetFrontendState();
  }

  async function applyDiscount(cart, couponCodeValue) {
    const discountAPI = "https://borosil-kart-discount.marmeto.com/discount"; // API ngrok Temp
    const customerId = parseInt(
      document.querySelector("discount-toggle").getAttribute("data-userId")
    );

    const applyText = document.getElementById("apply-text");
    const applyLoader = document.getElementById("apply-loader");
    const discountButton = document.querySelector("#discount-offer-showBtn");
    const discountOffShow = document.querySelector("#discount-price-offShow");
    const discountErrorEle = document.querySelector("#error-block-disocunt");

    const applieDiscountInBreakDown = document.querySelector(
      ".mm-ajaxcart-price-text.breakdown-applied-discount-price"
    );

    const applyButton = document.querySelectorAll(`.discount_cta_btn`);

    // loader and hide the "Apply" text
    applyText.style.display = "none";
    applyLoader.setAttribute("style", "display: block !important;");

    const data = {
      cart: cart,
      store: `${Shopify.shop}`,
      discount: couponCodeValue,
      customer_id: customerId,
    };

    try {
      const response = await fetch(discountAPI, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw { status: response.status, message: errorData.error };
      }

      //  JSON response
      const res = await response.json();
      discountErrorEle.style.display = "none"; // error hidden if response is ok

      window.sessionStorage.setItem("custom_coupon-code", couponCodeValue);

      document.cookie = `discount_code=${couponCodeValue}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
      const discountCode =
        res.data.response.formatted_text.discount_pair.discountCode;
      const finalTotalPrice =
        res.data.response.formatted_text.final_total_price;
      const totalPrice = res.data.response.formatted_text.total_price;
      const discountAmount = res.data.response.formatted_text.discount_amount;
      discountButton.innerHTML = `
  <span>${couponCodeValue}</span>
  <button class="discount-price-closeBtn" onclick="Shopify.DiscountRemove('${couponCodeValue}')">X</button>
`;

      discountOffShow.innerHTML = `<span>Discount:</span> <span> -₹${discountAmount}</span>`;
      applieDiscountInBreakDown.innerHTML = "-₹" + discountAmount;

      // Update UI with discounted price
      const initialCartPrice = document.querySelector("#inital-cart-price");
      const finalDiscountPriceElement = document.querySelector(
        "#final-disocunt-price"
      );
      if (finalDiscountPriceElement) {
        initialCartPrice.innerHTML = `₹${totalPrice}`;
        initialCartPrice.classList.add("discounted-price-main");
        finalDiscountPriceElement.innerHTML = `₹${finalTotalPrice}`;
      } else {
        console.warn('Element "final-discount-price" not found.');
      }

      const compareAtPriceDiv = document.querySelector(
        ".cart-compare-at-price"
      );
      if (compareAtPriceDiv) {
        const compareAtPrice = compareAtPriceDiv.dataset.mrp;
        const compareAt = compareAtPrice / 100;
        const finalPrice = parseFloat(finalTotalPrice);
        const discountPercentage = Math.round(
          ((compareAt - finalPrice) / compareAt) * 100
        );
        const discountPercentageDiv = document.querySelector(
          "cart-drawer .discount-percentage"
        );
        if (discountPercentageDiv && !isNaN(discountPercentage)) {
          discountPercentageDiv.innerHTML = `${discountPercentage}% off`;
        }
      }

      const discountElement = document.querySelector(".coupon-discount");
      if (discountElement) {
        discountElement.innerHTML = `
        <svg
  aria-hidden="true"
  focusable="false"
  class="icon icon-discount"
  viewBox="0 0 12 12"
>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
</svg>
${couponCodeValue} (- ₹ ${discountAmount} )
`;
      }

      applyButton.forEach((button) => {
        if (button && button.classList.contains(`${couponCodeValue}`)) {
          button.innerHTML = `<span class="after-apply-discount"> Applied </span>`;
        } else {
          button.innerHTML = `<span> Tap To Apply </span>`;
        }
      });
    } catch (error) {
      console.error("Error:", error);
      // error handling
      discountErrorEle.style.display = "block";
      const finalDiscountPriceElement = document.querySelector(
        "#final-disocunt-price"
      );
      finalDiscountPriceElement.innerHTML = "";
      let errorMessage = "An error occurred while applying the discount.";
      if (error.status === 404 || error.status === 403) {
        errorMessage =
          "Invalid discount code or the coupon is not available for your cart.";
      } else if (error.status === 0) {
        errorMessage = "Network error, please check your connection.";
      } else if (error.message === "signal is aborted without reason") {
        errorMessage = "Something went wrong, please try again later.";
      }

      discountErrorEle.innerHTML = `<span style="color: red;font-size:12px;line-height:1;font-weight:500;">${errorMessage}</span>`;
      triggerDiscountButtonClick();
      Shopify.DiscountRemove(couponCodeValue);
    } finally {
      applyLoader.setAttribute("style", "display: none !important;");
      applyText.style.display = "block";
      resetFrontendState();
    }
  }
};

Shopify.DiscountRemove = function (couponCodeValue) {
  const discountButton = document.querySelector("#discount-offer-showBtn");
  const discountOffShow = document.querySelector("#discount-price-offShow");
  const initialCartPrice = document.querySelector("#inital-cart-price");
  const finalDiscountPriceElement = document.querySelector(
    "#final-disocunt-price"
  );
  const applyLoader = document.getElementById("apply-loader");
  const applyText = document.getElementById("apply-text");
  const discountApplyBtn = document.querySelector("#apply-coupon-btn");
  const applyButton = document.querySelectorAll(`.discount_cta_btn`);
  const discountElement = document.querySelector(".coupon-discount");
  // Clear session storage and cookie related to the coupon
  sessionStorage.removeItem("custom_coupon-code");
  document.cookie =
    "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";

  // Undo the discount-related changes in the UI
  if (initialCartPrice) {
    initialCartPrice.classList.remove("discounted-price-main");
  }
  if (finalDiscountPriceElement) {
    finalDiscountPriceElement.innerHTML = "";
  }
  if (discountButton) {
    discountButton.innerHTML = "";
  }
  if (discountOffShow) {
    discountOffShow.innerHTML = "";
  }
  if (discountElement) {
    discountElement.innerHTML = "";
  }

  applyButton.forEach((button) => {
    if (button && button.classList.contains(`${couponCodeValue}`)) {
      button.innerHTML = `<span> Tap To Apply </span>`;
    }
  });
  // Reset the loader and apply button text states
  if (applyLoader) {
    applyLoader.setAttribute("style", "display: none !important;");
  }
  if (applyText) {
    applyText.style.display = "block";
  }

  const compareAtPriceDiv = document.querySelector(".cart-compare-at-price");
  if (compareAtPriceDiv) {
    const compareAtPrice = compareAtPriceDiv.dataset.mrp;
    const compareAt = compareAtPrice / 100;
    const finalPrice = parseFloat(
      document.querySelector("#inital-cart-price").innerHTML.split("₹")[1]
    );
    const discountPercentage = Math.round(
      ((compareAt - finalPrice) / compareAt) * 100
    );
    const discountPercentageDiv = document.querySelector(
      "cart-drawer .discount-percentage"
    );
    if (discountPercentageDiv && !isNaN(discountPercentage)) {
      discountPercentageDiv.innerHTML = `${discountPercentage}% off`;
    }
  }

  resetFrontendState();
};

// Reset frontend UI elements and states
function resetFrontendState() {
  document.querySelector("#custom-discount-text").value = "";
  if (discountWrapperElement) {
    discountWrapperElement.classList.remove("discount-applied");
  }
  if (discountApplyBtn) {
    discountApplyBtn.classList.remove("btn-loading");
    discountApplyBtn.removeAttribute("disabled");
  }
}
